import React from 'react';
import type { RolesTableHeaderProps } from './roleInterfaces';

export default function RolesTableHeader({ days, roleFilter, showNeedColumn = false }: RolesTableHeaderProps) {
    const TW_CELL_BG_COLOR = "bg-blue-600";
    const TW_TEXT_BG_COLOR = "text-white"
    return (
        <thead className={TW_TEXT_BG_COLOR}>
            <tr>
                <th className={`border border-gray-300 ${TW_CELL_BG_COLOR} px-2 py-1 font-semibold w-32`}>
                    <div className="flex items-center justify-center gap-2">
                        <span>Rôle</span>
                        {roleFilter}
                    </div>
                </th>
                {showNeedColumn && <th className={`border border-gray-300 ${TW_CELL_BG_COLOR} px-2 py-1 font-semibold`}>Gabarit</th>}
                <th className={`border border-gray-300 ${TW_CELL_BG_COLOR} px-2 py-1 font-semibold w-24`}></th>
                {days.map(day => (
                    <th key={day.date} className={`border border-gray-300 ${TW_CELL_BG_COLOR} px-2 py-1 font-semibold min-w-[140px]  w-100`}>
                        <div className="flex flex-col">
                            <span>{day.name}</span>
                            <span className={`text-xs font-normal ${TW_TEXT_BG_COLOR}`}>{day.displayDate}</span>
                        </div>
                    </th>
                ))}
                <th className={`border border-gray-300 ${TW_CELL_BG_COLOR} px-2 py-1 font-semibold`}></th>
            </tr>
        </thead>
    );
}
